import { z } from 'zod'
import type { ProfileListParams } from '@/api/endpoints/profiles'
import { listSearchSchema } from '@/lib/list-search'

export const profilesListSearchSchema = listSearchSchema.extend({
  without_accounts: z.boolean().optional().catch(undefined),
})

export type ProfilesListSearch = z.infer<typeof profilesListSearchSchema>

export function toProfileListParams(search: ProfilesListSearch): ProfileListParams {
  return {
    page: search.page,
    page_size: search.page_size,
    query: search.query,
    server: search.without_accounts === true ? undefined : search.server,
    without_accounts: search.without_accounts === true ? true : undefined,
  }
}
